import { LabelTemplate } from "../../styles/table";
import { Employee } from "../../../types/processTypes";
import Image from "mui-image";
import { Box, Stack, Typography } from "@mui/material";

interface Props {
  currentEmployee: Employee;
  template: LabelTemplate;
}
export const BasicPassportScan = ({ currentEmployee, template }: Props) => {
  return (
    <Stack alignItems="center">
      <Box alignItems="left">
        <Typography variant="h6">
          {"B(" + (currentEmployee.contactPerson?.kinship || "-") + ")"}
        </Typography>
        <Image
          src={
            currentEmployee.passportScan
              ? (currentEmployee.passportScan as string)
              : "/EthioPassport.png"
          }
          alt={currentEmployee.passportNumber}
          width={template.passportWidth}
          height={template.passportHeight}
          shift="top"
          distance="2rem"
          shiftDuration={320}
          style={{
            objectFit: "fill",
            borderRadius: template.borderRadius,
            borderColor: template.borderColor,
            borderWidth: (template.borderWidth as number) * 2,
            borderStyle: template.borderStyle,
            boxShadow: template.passportShadow,
          }}
        />
      </Box>
    </Stack>
  );
};
export const BasicPassportScanNoBroker = ({
  currentEmployee,
  template,
}: Props) => {
  return (
    <Stack alignItems="center">
      <Image
        src={
          currentEmployee.passportScan
            ? (currentEmployee.passportScan as string)
            : "/EthioPassport.png"
        }
        alt={currentEmployee.passportNumber}
        width={template.passportWidth}
        height={template.passportHeight}
        shift="top"
        distance="2rem"
        shiftDuration={320}
        style={{
          objectFit: "fill",
          borderRadius: template.borderRadius,
          borderColor: template.borderColor,
          borderWidth: (template.borderWidth as number) * 2,
          borderStyle: template.borderStyle,
          boxShadow: template.passportShadow,
        }}
      />
    </Stack>
  );
};
export const BasicPassportScanFixed = ({
  currentEmployee,
  template,
}: Props) => {
  return (
    <Stack alignItems="center">
      <Image
        src={
          currentEmployee.passportScan
            ? (currentEmployee.passportScan as string)
            : "/EthioPassport.png"
        }
        alt={currentEmployee.passportNumber}
        width="650px"
        height="700px"
        shift="top"
        distance="2rem"
        shiftDuration={320}
        style={{
          objectFit: "fill",
          // borderRadius: template.borderRadius,
          // borderColor: template.borderColor,
          // borderWidth: (template.borderWidth as number) * 2,
          // borderStyle: template.borderStyle,
          // boxShadow: template.passportShadow,
        }}
      />
    </Stack>
  );
};
